import { useState, useEffect } from 'react';
import { useKeycloak } from '../context/KeycloakContext';
import { useLocation } from 'react-router-dom';
import { Container, Alert } from 'react-bootstrap';
import { fetchAasEnvironment } from '../services/DppManagerService';
import { decodeBase64Url } from '../components/Utils';
import DppView from '../components/DppView';
import DppNotFoundPage from './DppNotFoundPage';
import NotAuthorizedPage from './NotAuthorizedPage';

const SearchResultPage = () => {
  const { isAuthenticated } = useKeycloak();

  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [errorCode, setErrorCode] = useState(null);
  const location = useLocation();

  // Extract the 'query' parameter
  const query = new URLSearchParams(location.search).get('query');
  const decodedQuery = query ? decodeBase64Url(query) : null;

  useEffect(() => {
    const fetchSearchResult = async () => {
      try {
        if (isAuthenticated() && query) {
          const aasEnvironment = await fetchAasEnvironment(query);
          setResult(aasEnvironment);
          setError(null);
          setErrorCode(null);
        }
      } catch (err) {
        const message = err.message || '';
        if (message.includes('404')) {
          setErrorCode(404);
        } else if (message.includes('403')) {
          setErrorCode(403);
        } else {
          setErrorCode(404);
        }
      }
    };

    fetchSearchResult();
  }, [query]);

  if (errorCode === 404) {
    return <DppNotFoundPage query={decodedQuery} />;
  }

  if (errorCode === 403) {
    return <NotAuthorizedPage />;
  }

  return (
    <Container className='py-3'>
      {result && (
        <div className="my-5">
          <DppView shell={result} query={query} />
        </div>
      )}
    </Container>
  );
};

export default SearchResultPage;